var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPintrest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 49,
    viewBox: "0 0 36 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62885 48.0201C9.37365 47.3144 12.5097 44.0997 14.1561 37.3959L15.4105 32.2994C16.5865 33.5148 18.1937 34.2989 19.8793 34.7301C26.7393 36.4159 33.4033 29.0848 35.1673 21.9889C37.5977 12.1096 32.5409 3.36718 24.1913 1.32859C14.5481 -1.02363 3.18005 3.68083 0.436053 14.9715C-0.543948 18.931 -0.230345 24.9684 5.17926 27.8302C5.72806 28.1439 6.39446 27.8302 6.55126 27.203L7.29605 24.1451C7.37445 23.7923 7.21766 23.4395 6.94326 23.165C5.02246 21.4401 4.59126 18.5782 5.21846 15.9124C7.10006 8.26766 14.9401 5.13135 21.6433 6.7779C27.4449 8.18923 30.9729 14.109 29.3265 20.8128C28.1505 25.5957 24.8577 30.8489 20.0753 29.6728C17.2137 28.9672 16.9001 26.1837 17.6841 23.0082L19.4481 15.8339C19.9185 13.9914 18.7817 12.1096 16.9393 11.6784C15.0969 11.2079 12.1569 12.5408 11.2161 16.3436C10.6673 18.5782 11.0985 20.3815 11.9609 21.5576L8.43285 35.9454C6.82565 42.5708 8.04085 46.844 8.39365 47.8633",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPintrest);
export default __webpack_public_path__ + "static/media/pintrest.ae92087047ee9f2f694878db9e4ba655.svg";
export { ForwardRef as ReactComponent };